import type { CharacterProfile } from '../types';
import { CHARACTER_SELECT_EXPLOSION_MS, CHARACTER_SELECT_FIGHT_MS, CHARACTER_SELECT_LEFT_MOVES_MS, CHARACTER_SELECT_READY_MS, CHARACTER_SELECT_RIGHT_MOVES_MS, completedSelectionMoves } from '../data/characterSelect';
import { FightImpactOverlay } from './FightImpactOverlay';
import { IdleFighterSprite } from './IdleFighterSprite';

export function CharacterSelectAttractScene({ characters, elapsedMs, fastMode }: { characters: CharacterProfile[]; elapsedMs: number; fastMode: boolean }) {
  const roster = characters.filter((character) => !character.isBoss);
  const leftMoves = completedSelectionMoves(elapsedMs, CHARACTER_SELECT_LEFT_MOVES_MS);
  const rightMoves = completedSelectionMoves(elapsedMs, CHARACTER_SELECT_RIGHT_MOVES_MS);
  const leftIndex = (leftMoves * 3) % roster.length;
  const rightIndex = (roster.length - 1 - rightMoves * 2 + roster.length) % roster.length;
  const left = roster[leftIndex];
  const right = roster[rightIndex === leftIndex ? (rightIndex + 1) % roster.length : rightIndex];
  const ready = elapsedMs >= CHARACTER_SELECT_READY_MS && elapsedMs < CHARACTER_SELECT_FIGHT_MS;
  const fight = elapsedMs >= CHARACTER_SELECT_FIGHT_MS;
  const explosion = elapsedMs >= CHARACTER_SELECT_EXPLOSION_MS;
  return (
    <main className={`attract-scene select-attract${fight ? ' is-engaging' : ''}`} aria-label="Automated character select preview">
      <h1>SELECT YOUR SMACKER</h1>
      <div className="select-attract__preview select-attract__preview--left"><span>P1</span><IdleFighterSprite character={left} side="left" fastMode={fastMode} /><b>{left.name}</b></div>
      <div className="select-attract__preview select-attract__preview--right"><span>CPU</span><IdleFighterSprite character={right} side="right" fastMode={fastMode} /><b>{right.name}</b></div>
      <div className="select-attract__roster">
        {roster.map((character, index) => <div key={character.id} className={`${index === leftIndex ? 'is-p1 ' : ''}${index === rightIndex ? 'is-cpu' : ''}`}><img src={character.images[0].srcSet.split(' ')[0]} alt="" width="80" height="80" /><span>{character.name}</span></div>)}
      </div>
      <p className={`select-attract__ready${ready ? ' is-visible' : ''}`}>READY</p>
      <FightImpactOverlay fight={fight} explosion={explosion} />
    </main>
  );
}
